import React from "react"
import "./NotFound.css"

function NotFound() {
  return (
    <div className="NotFound">
      <h1>404</h1>
      <h3>Sorry, page not found!</h3>
    </div>
  )
}

export default NotFound
